import $ from "jquery";

const required = "<abbr title='required'>*</abbr> ";
const requiredRegexp = /<abbr title="required">\*<\/abbr> /;

$(document).on("turbolinks:load cocoon:after-insert", function () {
  $(".require-all-if-any-init").each(function () {
    const $this = $(this);
    const selector = $this.data("requireAllIfAnySelector");

    const $all = $("." + selector);
    const $allThatCanTriggerRequireAll = $all.filter(":not(.require-all-if-solo-ignore)");

    const handleChange = function () {
      const valuesThatCanTriggerRequire = $allThatCanTriggerRequireAll.map(function () { return $(this).val(); }).get();

      const anyHaveValue = valuesThatCanTriggerRequire.some(function (v) { return !!v; });
      if (anyHaveValue) {
        $all.prop("required", true);
        $all.each(function () {
          const $input = $(this);

          const $label = $input.closest(".form-group").find("label");

          if (!$label.html().match(requiredRegexp)) {
            $label.html(required + $label.html());
          }
        });
      } else {
        $all.prop("required", false);
        $all.each(function () {
          const $input = $(this);

          const $label = $input.closest(".form-group").find("label");

          $label.html($label.html().replace(requiredRegexp, ""));
        });
      }
    };
    handleChange();
    $all.on("change", handleChange);
  });
});
